const config = {
    DOMAIN: 'https://in.interviewer.ai',
    LOGO: 'https://interviewer-ai-assets.s3-ap-southeast-1.amazonaws.com/site/Interviewer-ai-logo-transparent-128x128.png',
};

export default config;
